import { RootState } from "../types";

export const getApplicationBreakpoint = (state: RootState) => state.application.breakPoint;
export const getApplicationMode = (state: RootState) => state.application.mode;
export const getSelectedYear = (state: RootState) => state.application.selectedYear;
export const getSelectedMonth = (state: RootState) => state.application.selectedMonth;
export const getDeviceToken = (state: RootState) => state.application.deviceToken;
